import {store} from "@/store"
import {Vue} from "vue-property-decorator"

export default class BaseVue extends Vue {
    protected get $typedStore() {
        return store
    }
}
